<template>
  <div class="row" v-if="rebuild">
    <loading
      class="custom-loading-overlay"
      :active="isLoading"
      :color="loadingColor"
      :isFullPage="true"
    ></loading>
    <div class="col-12" style="padding-left: 5px; padding-right: 5px">
      <div
        class="card card-style"
        style="background-color: white; margin-left: 0px; margin-right: 0px"
      >
        <div class="card-body">
          <h3 class="card-title">Editar Perfil</h3>
          <!-- <div class="form-group">
            <label for="inputField" class="col-form-label">Login:</label>
            <div class="custom-input-container">
              <input
                type="text"
                style="background-color: #efefef"
                v-model="users.login"
                class="custom-input"
                :disabled="isDisabled"
              />
            </div>
          </div> -->
          <div class="form-group">
            <label for="inputField" class="col-form-label">Nome:</label>
            <div class="custom-input-container">
              <input
                type="text"
                v-model="users.usuario_nome"
                class="custom-input"
              />
            </div>
          </div>
          <div class="form-group">
            <label for="inputField" class="col-form-label">CPF:</label>
            <div class="custom-input-container">
              <input
                type="text"
                disabled
                v-model="users.cpf"
                class="custom-input"
              />
            </div>
          </div>
          <div class="form-group">
            <label for="inputField" class="col-form-label">
              <span class="required">*</span> Telefone:</label
            >
            <div class="custom-input-container">
              <input
                type="tel"
                v-model="users.telefone"
                class="custom-input"
                v-mask="'(99) 99999-9999'"
              />
            </div>
          </div>
          <div class="form-group">
            <label for="inputField" class="col-form-label"
              ><span class="required">*</span> Data de Nascimento:</label
            >
            <div class="custom-input-container">
              <input
                autocomplete="new-password"
                type="date"
                id="Name"
                class="form-control custom-input"
                v-model="users.paciente.data_nascimento"
              />
            </div>
          </div>
          <div class="form-group">
            <label for="Name"> <span class="required">*</span> Sexo: </label>
            <select
              class="form-select custom-input"
              type="select"
              v-model="users.paciente.sexo"
            >
              <option value="M">Masculino</option>
              <option value="F">Feminino</option>
            </select>
          </div>
          <div class="form-group">
            <label for="inputField" class="col-form-label">CEP:</label>
            <div class="custom-input-container">
              <input
                type="tel"
                v-model="users.paciente.cep"
                class="custom-input"
                v-on:keyup="buscar"
                v-mask="'99999-999'"
              />
            </div>
          </div>
          <div class="form-group">
            <label for="inputField" class="col-form-label">Logradouro:</label>
            <div class="custom-input-container">
              <input
                type="text"
                v-model="users.paciente.endereco"
                class="custom-input"
              />
            </div>
          </div>
          <div class="form-group">
            <label for="inputField" class="col-form-label">Número:</label>
            <div class="custom-input-container">
              <input
                type="text"
                v-model="users.paciente.numero"
                class="custom-input"
                id="inputNumero"
              />
            </div>
          </div>
          <div class="form-group">
            <label for="inputField" class="col-form-label">Bairro:</label>
            <div class="custom-input-container">
              <input
                type="text"
                v-model="users.paciente.bairro"
                class="custom-input"
              />
            </div>
          </div>
          <div class="form-group">
            <label for="inputField" class="col-form-label">Estado:</label>
            <div class="custom-input-container">
              <input
                type="text"
                v-model="users.paciente.uf"
                class="custom-input"
              />
            </div>
          </div>
          <div class="form-group">
            <label for="inputField" class="col-form-label">Cidade:</label>
            <div class="custom-input-container">
              <input
                type="text"
                v-model="users.paciente.cidade"
                class="custom-input"
              />
            </div>
          </div>
          <div class="form-group">
            <label for="inputField" class="col-form-label">Complemento:</label>
            <div class="custom-input-container">
              <input
                type="text"
                v-model="users.paciente.complemento"
                class="custom-input"
              />
            </div>
          </div>

          <div class="form-group">
            <label for="inputField" class="col-form-label">Deficiência:</label>
            <div class="custom-input-container">
              <textarea
                v-model="users.paciente.deficiencia"
                style="height: 83px"
                maxlength="260"
                class="custom-input"
              />
            </div>
          </div>
          <!-- <div class="form-group">
                      <label for="inputUser">
                          <span class="required">*</span> Nível de acesso:
                        </label>
                        <select
                            class="form-control form-select custom-input"
                            v-model="users.perfil_id"
                            
                          >
                            <option
                              v-for="perfil_usuario in perfil_usuarios"
                              :key="perfil_usuario.perfil_id"
                              :value="perfil_usuario.perfil_id"
                            >
                              {{ perfil_usuario.perfil_nome }}
                            </option>
                          </select>
                    </div>  -->
          <br />
          <div @click="save()" class="form-group botao-salvar">
            <div class="col-md-12">
              <button type="button" class="btn">SALVAR</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
export default {
  data() {
    return {
      users: {
        usuario_nome: "",
        login: "",
        senha: "",
        perfil_id: "",
        senha_confirmacao: "",
        paciente: {
          endereco: "",
          numero: "",
          cep: "",
          cidade: "",
          uf: "",
          complemento: "",
          bairro: "",
          telefone: "",
        },
      },
      isLoading: false,
      loadingColor: "#5D9CEC",
      isDisabled: true,
      rebuild: true,
    };
  },
  computed: {},
  methods: {
    buscar: function () {
      var self = this;

      console.log("teste", self.users.paciente.cep.length);

      if (self.users.paciente.cep.slice(-1) == "_") {
        return;
      }

      self.naoLocalizado = false;
      self.rebuild = false;

      if (/^[0-9]{5}-[0-9]{3}$/.test(this.users.paciente.cep)) {
        $.getJSON(
          "https://viacep.com.br/ws/" + this.users.paciente.cep + "/json/",
          function (endereco) {
            if (endereco.erro) {
              self.endereco = {};
              $("#inputNumero").focus();
              self.naoLocalizado = true;
              self.rebuild = true;
              return;
            }
            self.endereco = endereco;
            self.users.paciente.endereco = self.endereco.logradouro;
            self.users.paciente.bairro = self.endereco.bairro;
            self.users.paciente.cidade = self.endereco.localidade;
            self.users.paciente.uf = self.endereco.uf;
            $("#inputNumero").focus();

            self.rebuild = true;
          }
        );
      }
    },
    /* changeStatusReceive(object) {
      const self = this;
      const api = self.$store.state.api + "teste";

      self.isLoading = true;

      self.$http
        .post(api, object)
        .then((response) => {})
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    }, */
    // makeFormData: function () {
    //   const self = this;
    //   let fd = new FormData();

    //   let photo = document.getElementById("userPic");

    //   fd.append("usuario_nome", self.users.usuario_nome);
    //   fd.append("login", self.users.login);
    //   fd.append("perfil_id", self.users.perfil_id);
    //   fd.append("senha", self.users.senha);
    //   fd.append("senha_confirmacao", self.users.senha_confirmacao);
    //   fd.append(
    //     "endereco",
    //     self.users.endereco ? self.users.endereco : ""
    //   );
    //   fd.append("numero", self.users.numero ? self.users.numero : "");
    //   fd.append("cep", self.users.cep ? self.users.cep : "");
    //   fd.append("cidade", self.users.cidade ? self.users.cidade : "");
    //   fd.append("uf", self.users.uf ? self.users.uf : "");
    //   fd.append(
    //     "complemento",
    //     self.users.complemento ? self.users.complemento : ""
    //   );
    //   fd.append("bairro", self.users.bairro ? self.users.bairro : "");
    //   fd.append(
    //     "deficiencia",
    //     self.users.deficiencia ? self.users.deficiencia : ""
    //   );

    //   // fd.append("foto", photo.files[0] ? photo.files[0] : "");

    //   if (self.users.id) {
    //     fd.append("id", self.users.id);
    //     fd.append("_method", "PUT");
    //   }

    //   return fd;
    // },
    save() {
      const self = this;
      self.isLoading = true;
      let api = self.$store.state.api + "users";

      // let fd = self.makeFormData();

      if (self.users.id) {
        self.users._method = "PUT";
        api += "/" + self.users.id;
      }
      axios
        .post(api, self.users)
        .then((response) => {
          self.isLoading = false;
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/dashboard");          
          this.$store.commit('profileUpdate');
        })
        .catch((error) => {
          self.isLoading = false;
          self.$message(null, error.response.data, "error");
        });
    },
    getUsers(id) {
      const self = this;
      const api = self.$store.state.api + "users/" + id + "?with[]=paciente";

      axios
        .get(api)
        .then((response) => {
          self.users = response.data.data[0];
          delete self.users.foto;
          if (!self.users.paciente) {
            self.users.paciente = {
              endereco: "",
              numero: "",
              cep: "",
              cidade: "",
              uf: "",
              complemento: "",
              bairro: "",
            };
          } else {
            self.users.paciente.cidade = self.users.paciente.nome_municipio;
            self.users.paciente.uf = self.users.paciente.nome_estado;
          }
          self.isLoading = false;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
          self.isLoading = false;
        });
    },
    getPerfilUsuario() {
      const self = this;
      let api =
        self.$store.state.api + "perfil_usuarios?paginated=false&status=1";
      self.isLoading = true;
      axios
        .get(api)
        .then((response) => {
          self.isLoading = false;
          self.perfil_usuarios = response.data.data;
        })
        .catch((error) => {
          self.isLoading = false;
          self.$message(null, error.response.data, "error");
        });
    },
  },
  components: { Loading },
  props: {},
  mounted() {
    const self = this;
    self.isLoading = true;
    self.getPerfilUsuario();

    $("#menu-main").removeClass("show");
    $(".offcanvas-backdrop.show").removeClass("show");
    /* $(".theme-light").removeAttribute("style","overflow: hidden; padding-right: 0px;"); */
    document.body.setAttribute("style", null);

    setTimeout(() => {
      let id = self.$store.state.user.usuario_id;
      if (id) {
        /* self.change_password = false; */
        self.getUsers(id);
      }
    }, 1000);
  },
};
</script>
<style scoped>
/* CUSTOMIZACOES VUE LOADING */
.custom-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0);
  backdrop-filter: blur(3px);
  opacity: 0.98;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.custom-loading-spinner {
  width: 100px;
  height: 100px;
  z-index: 10000;
}

/* CUSTOMIZACOES INPUTS */
.custom-input {
  border-radius: 0;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}

.input-group > .form-control {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  margin-bottom: 0;
}

.input-group > .form-control:focus {
  z-index: 3;
}

.custom-input-container {
  position: relative;
}

.custom-input {
  padding: 0.375rem 0.75rem;
  height: 2.714rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  box-shadow: 0 0.2rem 0.5rem rgba(0, 0, 0, 0.15);
  width: 100%;
}

.custom-input:focus {
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.botao-salvar {
  position: fixed;
  bottom: 0;
  width: 100%;
  padding-left: 10px;
  padding-right: 10px;
}

.btn {
  width: 100% !important;
  background-color: rgb(21, 72, 138) !important;
  margin: 0px 15px 18px -29px;
}

.form-group {
  margin-bottom: 9px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/EditarPerfil.vue